import { useMutation } from "@tanstack/react-query";

import { ChatsApi } from "@/api/chats";
import { FilesApi } from "@/api/files";
import { Chat } from "@/types";
import { useNotify } from "react-admin";

const useUploadImage = () => {
  const notify = useNotify();

  const { mutate, isPending } = useMutation({
    mutationFn: async ({
      chatId,
      imageFile,
    }: {
      chatId: Chat["id"];
      imageFile: File;
    }) => {
      const imageFormData = new FormData();
      imageFormData.append("file", imageFile);

      const imageFileSource = await FilesApi.uploadImage(imageFormData);
      await ChatsApi.sendMessage({
        chatId,
        attachments: [imageFileSource],
        body: "Image attachment",
        isViewOnce: false,
      });
    },
    onError: (error) => {
      notify(error, { type: "error" });
    },
  });

  return { uploadImage: mutate, isUploadImageLoading: isPending };
};

export { useUploadImage };
